export default {
  modals: [],
  // Designators that asked Modal.vue to intercept its own X-close (UI reviewer
  // issue 2). ESC and backdrop-close do not exist in Modal.vue — only the X
  // triggers closeModal(), so this flag is the single interception point.
  dirtyGuard: {}
}
